import { create, v, w } from '@dojo/framework/core/vdom';
import { icache } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Tooltip, Orientation } from '@dojo/widgets/tooltip';
import { Button } from '@dojo/widgets/button';
import css from '../css/progress-tracker.m.css';
const factory = create({
    icache,
    theme
}).properties();
export const TestStatusIcon = factory(({ properties, middleware: { icache, theme } }) => {
    const { tip, isTaken, isPassed } = properties();
    const themeCss = theme.classes(css);
    const showTip = () => icache.set('showTip', true);
    const hideTip = () => icache.set('showTip', false);
    const icon = () => {
        if (isTaken && isPassed) {
            return v('i', { classes: ['far', 'fa-check-circle', 'fa-stack-2x', themeCss.completed] });
        }
        else if (isTaken && !isPassed) {
            return v('i', { classes: ['far', 'fa-check-circle', 'fa-stack-2x'] });
        }
        else {
            return v('i', { classes: ['far', 'fa-circle', 'fa-stack-2x'] });
        }
    };
    const button = w(Tooltip, { open: icache.getOrSet('showTip', false), orientation: Orientation.top }, [
        {
            content: tip,
            trigger: w(Button, {
                onOver: showTip,
                onOut: hideTip,
                onFocus: showTip,
                onBlur: hideTip
            }, [icon()])
        }
    ]);
    return v('div', { class: themeCss.statusIcon }, [button]);
});
export default TestStatusIcon;
